import { EnumBase } from 'hay-core-react';
class TipoLoginEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.configuracao.tipologin.telefone',
                'main.configuracao.tipologin.email',
                'main.configuracao.tipologin.cpf',
            ],
            'main.configuracao.tipologin.email'
        );
    }
}

const instance = new TipoLoginEnum();
export default instance;
